export default __webpack_public_path__ + "static/1137-dcaeab01c153ca8cd28f0950f82758c3.gif";